<template>
  <v-container
    id="contas-receber-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <div>
      <v-row>
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
        >
          <dashboard-filtro-datas
            :primeiro="enablePrimeiroDia"
            :ultimo="enableUltimoDia"
            :empresas="enableEmpresa"
            :cliente="enableClientes"
            :url="link"
          />
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="3"
            >
              <v-card
                id="cardDashbord"
                class="mx-auto"
                outlined
              >
                <div class="card-header-dashbord">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="10"
                      md="10"
                      lg="10"
                      class="d-flex flex-wrap"
                    >
                      Valores a Receber
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                      lg="2"
                      class="d-flex justify-end"
                    >
                      <v-tooltip
                        top
                        max-width="400"
                        width="400"
                      >
                        <template
                          v-slot:activator="{ on, attrs }"
                        >
                          <v-icon
                            id="iconInformationFatxMetaComercial4"
                            class="text-left"
                            v-bind="attrs"
                            v-on="on"
                            @mouseover="enableTexto('200')"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div
                          v-if="!carregandoTooltip"
                          v-html="textoOrientacao"
                        />
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
                <v-card-actions>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <v-row v-if="loading">
                        <div
                          id="loadingDados"
                          :style="styleObject"
                          class="text-center"
                        >
                          <v-icon
                            light
                            class="custom-loader"
                            :style="styleObject"
                          >
                            mdi-cached
                          </v-icon>
                          Carregando dados...
                        </div>
                      </v-row>
                      <v-row v-else-if="error">
                        <span
                          class="alert alert-danger"
                        >
                          {{ error }}
                        </span>
                      </v-row>
                      <v-row v-else>
                        <v-col
                          cols="12"
                          sm="12"
                          md="12"
                          lg="12"
                          class="text-right"
                        >
                          <v-row>
                            <v-col
                              id="valorReceberId"
                              cols="12"
                              sm="11"
                              md="11"
                              lg="11"
                              class="text-right"
                              :style="styleObject"
                            >
                              {{ valorReceber }}
                            </v-col>
                            <v-col
                              id="iconLinkDetalheAReceber"
                              cols="12"
                              sm="1"
                              md="1"
                              lg="1"
                              class="text-right"
                            >
                              <router-link
                                to="/contas-receber/valor-a-receber"
                                :style="styleObject"
                              >
                                <v-icon
                                  class="text-right"
                                >
                                  mdi-dots-vertical
                                </v-icon>
                              </router-link>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="3"
            >
              <v-card
                id="cardDashbord"
                class="mx-auto"
                outlined
              >
                <div class="card-header-dashbord">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="10"
                      md="10"
                      lg="10"
                      class="d-flex flex-wrap"
                    >
                      Valores Recebidos
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                      lg="2"
                      class="d-flex justify-end"
                    >
                      <v-tooltip
                        top
                        max-width="400"
                        width="400"
                      >
                        <template
                          v-slot:activator="{ on, attrs }"
                        >
                          <v-icon
                            id="iconInformationFatxMetaComercial4"
                            class="text-left"
                            v-bind="attrs"
                            v-on="on"
                            @mouseover="enableTexto('201')"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div
                          v-if="!carregandoTooltip"
                          v-html="textoOrientacao"
                        />
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
                <v-card-actions>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <dashboard-valor-receber id="componenteValorReceber" />
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="3"
            >
              <v-card
                id="cardDashbord"
                class="mx-auto"
                outlined
              >
                <div class="card-header-dashbord">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="10"
                      md="10"
                      lg="10"
                      class="d-flex flex-wrap"
                    >
                      Valores em Aberto
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                      lg="2"
                      class="d-flex justify-end"
                    >
                      <v-tooltip
                        top
                        max-width="400"
                        width="400"
                      >
                        <template
                          v-slot:activator="{ on, attrs }"
                        >
                          <v-icon
                            id="iconInformationFatxMetaComercial4"
                            class="text-left"
                            v-bind="attrs"
                            v-on="on"
                            @mouseover="enableTexto('202')"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div
                          v-if="!carregandoTooltip"
                          v-html="textoOrientacao"
                        />
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
                <v-card-actions>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <dashboard-valor-aberto id="componenteValorReceber" />
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="3"
            >
              <v-card
                id="cardDashbord"
                class="mx-auto"
                outlined
              >
                <div class="card-header-dashbord">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="10"
                      md="10"
                      lg="10"
                      class="d-flex flex-wrap"
                    >
                      Valores Vencidos
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                      lg="2"
                      class="d-flex justify-end"
                    >
                      <v-tooltip
                        top
                        max-width="400"
                        width="400"
                      >
                        <template
                          v-slot:activator="{ on, attrs }"
                        >
                          <v-icon
                            id="iconInformationFatxMetaComercial4"
                            class="text-left"
                            v-bind="attrs"
                            v-on="on"
                            @mouseover="enableTexto('203')"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div
                          v-if="!carregandoTooltip"
                          v-html="textoOrientacao"
                        />
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
                <v-card-actions>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <dashboard-valor-vencido id="componenteValorReceber" />
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          id="valorJurosRecebimento"
          cols="12"
          sm="12"
          md="6"
          lg="3"
        >
          <dashoard-card-view
            :exibir-texto-titulo="true"
            :code-information="'204'"
            :text="'Juros Recebidos'"
            :texto-information="textoJurosRecebido"
            :style-object="styleObject"
            :componente-valor="true"
            :valor="valorJurosRecebido"
            :padding="dynamicPaddingContasReceber2"
            :loading="loadingJurosRecebido"
          />
        </v-col>
        <v-col
          id="valorDescontoRecebimento"
          cols="12"
          sm="12"
          md="6"
          lg="3"
        >
          <dashoard-card-view
            :exibir-texto-titulo="true"
            :code-information="'205'"
            :text="'Descontos Concedidos'"
            :texto-information="textoDesconto"
            :style-object="styleObject"
            :componente-valor="true"
            :valor="valorDesconto"
            :padding="dynamicPaddingContasReceber2"
            :loading="loadingDescontoConcedido"
          />
        </v-col>
        <v-col
          id="prazoMedioVendas"
          cols="12"
          sm="12"
          md="6"
          lg="3"
        >
          <dashoard-card-view
            :exibir-texto-titulo="true"
            :code-information="'206'"
            :text="'Prazo Médio de Vendas (PMV)'"
            :texto-information="textoPMV"
            :style-object="styleObject"
            :componente-valor="true"
            :valor="`${valorPrazoMedio} dias`"
            :padding="dynamicPaddingContasReceber2"
            :loading="loadingPrazoMedioVendas"
          />
        </v-col>
        <v-col
          id="prazoMedioRecebimento"
          cols="12"
          sm="12"
          md="6"
          lg="3"
        >
          <dashoard-card-view
            :exibir-texto-titulo="true"
            :code-information="'207'"
            :text="'Prazo Médio Recebimento (PMR)'"
            :texto-information="textoPMR"
            :style-object="styleObject"
            :componente-valor="true"
            :valor="`${valorPrecoMedio} dias`"
            :padding="dynamicPaddingContasReceber2"
            :loading="loadingPrazoMedioRecebimento"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          id="prazoMedioRecebimento"
          cols="12"
          sm="12"
          md="12"
          lg="12"
        >
          <show-acompanhamento-diario />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          id="colunaShare"
          cols="12"
          sm="12"
          md="12"
          lg="2"
        >
          <v-row>
            <v-col
              id="componenteContasReceberInadimplentes"
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <v-card
                id="cardDashbord"
                class="mx-auto"
                outlined
              >
                <div class="card-header-dashbord">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="10"
                      md="10"
                      lg="10"
                      class="d-flex flex-wrap"
                    >
                      Inadimplência Geral
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                      lg="2"
                      class="d-flex justify-end"
                    >
                      <v-tooltip
                        top
                        max-width="400"
                        width="400"
                      >
                        <template
                          v-slot:activator="{ on, attrs }"
                        >
                          <v-icon
                            id="iconInformationFatxMetaComercial4"
                            class="text-left"
                            v-bind="attrs"
                            v-on="on"
                            @mouseover="enableTexto('209')"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div
                          v-if="!carregandoTooltip"
                          v-html="textoOrientacao"
                        />
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
                <v-card-actions>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                      class="text-right"
                    >
                      <v-row v-if="loadingValorInadimplencia">
                        <div
                          id="loadingDados"
                          :style="styleObjectInadimplente"
                          class="text-center"
                        >
                          <v-icon
                            light
                            class="custom-loader"
                            :style="styleObjectInadimplente"
                          >
                            mdi-cached
                          </v-icon>
                          Carregando dados...
                        </div>
                      </v-row>
                      <v-row v-else-if="errorValorInadimplencia">
                        <span
                          class="alert alert-danger"
                        >
                          {{ errorValorInadimplencia }}
                        </span>
                      </v-row>
                      <v-row>
                        <v-col
                          v-if="valorInadimplencia"
                          id="valorInadimplenciaId"
                          :style="styleObjectInadimplente"
                          cols="12"
                          sm="10"
                          md="10"
                          lg="10"
                          class="text-right"
                        >
                          {{ valorInadimplencia }}
                        </v-col>
                        <v-col
                          v-if="valorInadimplencia"
                          cols="12"
                          sm="1"
                          md="1"
                          lg="1"
                          class="text-right"
                        >
                          <router-link
                            to="/contas-receber/detalhamento-inadimplencia"
                            :style="styleObject"
                          >
                            <v-icon
                              id="iconLinkDetalheInadimplencia"
                              class="text-left"
                            >
                              mdi-dots-vertical
                            </v-icon>
                          </router-link>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col
              id="componenteContasReceberInadimplentes"
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <v-card
                id="cardDashbord"
                class="mx-auto"
                outlined
              >
                <div class="card-header-dashbord">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="10"
                      md="10"
                      lg="10"
                      class="d-flex flex-wrap"
                    >
                      Clientes inadimplentes
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                      lg="2"
                      class="d-flex justify-end"
                    >
                      <v-tooltip
                        top
                        max-width="400"
                        width="400"
                      >
                        <template
                          v-slot:activator="{ on, attrs }"
                        >
                          <v-icon
                            id="iconInformationFatxMetaComercial4"
                            class="text-left"
                            v-bind="attrs"
                            v-on="on"
                            @mouseover="enableTexto('210')"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div
                          v-if="!carregandoTooltip"
                          v-html="textoOrientacao"
                        />
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
                <v-card-actions>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                      class="text-right"
                    >
                      <v-row v-if="loading3">
                        <div
                          id="loadingDados"
                          :style="styleObject"
                          class="text-center"
                        >
                          <v-icon
                            light
                            class="custom-loader"
                            :style="styleObject"
                          >
                            mdi-cached
                          </v-icon>
                          Carregando dados...
                        </div>
                      </v-row>
                      <v-row v-else-if="error">
                        <span
                          class="alert alert-danger"
                        >
                          {{ error3 }}
                        </span>
                      </v-row>
                      <v-row>
                        <v-col
                          v-if="valorInadimplencia"
                          id="valorClientesInadimplentesId"
                          class="text-right"
                          :style="styleObjectClientesInadimplentes"
                          cols="12"
                          sm="10"
                          md="10"
                          lg="10"
                        >
                          {{ valorClientesInadimplentes }}
                        </v-col>
                        <v-col
                          v-if="valorInadimplencia"
                          cols="12"
                          sm="1"
                          md="1"
                          lg="1"
                        >
                          <router-link
                            to="/contas-receber/detalhamento-inadimplencia-clientes"
                            :style="styleObject"
                          >
                            <v-icon
                              id="iconLinkDetalheClientesInadimplencia"
                              class="text-left"
                            >
                              mdi-dots-vertical
                            </v-icon>
                          </router-link>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col
              id="componenteContasReceberInadimplentes"
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <dashoard-card-view
                :exibir-texto-titulo="true"
                :code-information="'211'"
                :text="'Share da Inadimplência'"
                :texto-information="textoShareInadimpl"
                :style-object="styleObject"
                :componente-grafico="true"
                :grafico-id="'myChart22'"
                :dados-grafico="chartShareRecebimento"
                :titulo-id="'myChart22'"
                :exibir-legenda="true"
                :padding="dynamicPaddingContasReceber5"
                :loading="loadingShareInadimplencia"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col
          id="componenteContasReceberInadimplentes"
          cols="12"
          sm="12"
          md="12"
          lg="5"
        >
          <v-card
            id="cardDashbord"
            class="mx-auto"
            outlined
          >
            <div class="card-header-dashbord">
              <v-row>
                <v-col
                  cols="12"
                  sm="10"
                  md="10"
                  lg="10"
                  class="d-flex flex-wrap"
                >
                  Títulos Vencidos até 7 dias
                </v-col>
                <v-col
                  cols="12"
                  sm="2"
                  md="2"
                  lg="2"
                  class="d-flex justify-end"
                >
                  <v-tooltip
                    top
                    max-width="400"
                    width="400"
                  >
                    <template
                      v-slot:activator="{ on, attrs }"
                    >
                      <v-icon
                        id="iconInformationFatxMetaComercial4"
                        class="text-left"
                        v-bind="attrs"
                        v-on="on"
                        @mouseover="enableTexto('212')"
                      >
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <div
                      v-if="!carregandoTooltip"
                      v-html="textoOrientacao"
                    />
                  </v-tooltip>
                </v-col>
              </v-row>
            </div>
            <v-card-actions>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                  <span
                    id="valorTituloVencidosId"
                  >
                    Valor Total
                  </span>
                  <show-valor-sete-dias-vencidos-contas-receber />
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col
          id="componenteContasReceberInadimplentes"
          cols="12"
          sm="12"
          md="12"
          lg="5"
        >
          <v-card
            id="cardDashbord"
            class="mx-auto"
            outlined
          >
            <div class="card-header-dashbord">
              <v-row>
                <v-col
                  cols="12"
                  sm="10"
                  md="10"
                  lg="10"
                  class="d-flex flex-wrap"
                >
                  Títulos Vencidos de 7 a 21 dias
                </v-col>
                <v-col
                  cols="12"
                  sm="2"
                  md="2"
                  lg="2"
                  class="d-flex justify-end"
                >
                  <v-tooltip
                    top
                    max-width="400"
                    width="400"
                  >
                    <template
                      v-slot:activator="{ on, attrs }"
                    >
                      <v-icon
                        id="iconInformationFatxMetaComercial4"
                        class="text-left"
                        v-bind="attrs"
                        v-on="on"
                        @mouseover="enableTexto('213')"
                      >
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <div
                      v-if="!carregandoTooltip"
                      v-html="textoOrientacao"
                    />
                  </v-tooltip>
                </v-col>
              </v-row>
            </div>
            <v-card-actions>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                  <span
                    id="valorTituloVencidosId"
                  >
                    Valor Total
                  </span>
                  <show-valor-vinte-dias-vencidos-contas-receber />
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          id="componenteContasReceberInadimplentes"
          cols="12"
          sm="12"
          md="12"
          lg="12"
        >
          <show-movimentacao-mes />
        </v-col>
      </v-row>

      <dashboard-core-snackbar
        v-model="snackbar.visible"
        :visible="snackbar.visible"
        :timeout="snackbar.timeout"
        :color="snackbar.color"
        :message="snackbar.message"
      />
    </div>
  </v-container>
</template>

<script>
  import Permissao from '../../../../services/menu'
  import ContasReceber from '../../../../services/contasreceber'
  import eventEmit from '../../components/core/EventoEmit'
  import Chart from 'chart.js'
  import ChartDataLabels from 'chartjs-plugin-datalabels'

  const pluginContasReceber = {
    id: 'centerText',
    beforeDraw (chart) {
      const centerConfig = chart.config.options.elements?.center
      if (!centerConfig) return

      const ctx = chart.chart.ctx
      const txt = centerConfig.text
      const fontStyle = centerConfig.fontStyle || 'Arial'
      const color = centerConfig.color || '#000'

      const width = chart.chartArea.right - chart.chartArea.left
      const height = chart.chartArea.bottom - chart.chartArea.top

      const fontSize = Math.min(width, height) / 3.5

      ctx.save()
      ctx.font = `${fontStyle} ${fontSize}px Arial`
      ctx.fillStyle = color
      ctx.textAlign = 'center'
      ctx.textBaseline = 'middle'

      const centerX =
        (chart.chartArea.left + chart.chartArea.right) / 2
      const centerY =
        (chart.chartArea.top + chart.chartArea.bottom + 30) / 2

      ctx.fillText(txt, centerX, centerY)
      ctx.restore()
    },
  }

  export default {
    name: 'DashboardContasReceber',
    emits: ['setValoresRecebidos', 'setValoresAberto', 'setValoresVencidos', 'setAcompanhamentoDiario', 'setMovimentacaoMesAMes', 'setJurosDesconto', 'enableFaturamento', 'disableLoading', 'disableLoadingGrafico', 'atualizarTexto'],
    components: {
      DashboardFiltroDatas: () => import('../../components/core/FiltroDatas'),
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
      DashoardCardView: () => import('../../components/core/CardView'),
      DashboardValorReceber: () => import('../../graficos/ContasReceber/ValorRecebido'),
      DashboardValorAberto: () => import('../../graficos/ContasReceber/ValorAberto'),
      DashboardValorVencido: () => import('../../graficos/ContasReceber/ValorVencido'),
      ShowAcompanhamentoDiario: () => import('../../graficos/ContasReceber/AcompanhamentoDiario'),
      ShowValorSeteDiasVencidosContasReceber: () => import('../../components/financeiro/contasReceber/ContasReceberValorTituloVencidosSeteDias'),
      ShowValorVinteDiasVencidosContasReceber: () => import('../../components/financeiro/contasReceber/ContasReceberValorTituloVencidosVinteDias'),
      ShowMovimentacaoMes: () => import('../../graficos/ContasReceber/MovimentacaoMesAMes'),
    },

    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleObjectInadimplente: {
        color: '#f27686',
      },
      styleObjectClientesInadimplentes: {
        color: '#757575',
      },
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      enableClientes: true,
      link: window.location.href,
      paginaEnable: true,
      permissaoContasReceber: '',
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      selectClientes: [],
      valorReceber: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorReceberEnviar: 0,
      valorVencido: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorVencidoEnviar: 0,
      valorClientesInadimplentes: 0,
      valorInadimplencia: 0,
      loading: false,
      error: null,
      loading3: false,
      error3: null,
      loadingValorInadimplencia: false,
      errorValorInadimplencia: null,
      codigo: 0,
      orientacao: [],
      textoVlrReceber: '',
      textoVlrRecebido: '',
      textoVlrAberto: '',
      textoVlrVencido: '',
      textoJurosRecebido: '',
      textoDesconto: '',
      textoPMV: '',
      textoPMR: '',
      textoAcompDiario: '',
      textoInadimplenciaGeral: '',
      textoClientesInadimpl: '',
      textoShareInadimpl: '',
      textoTituloVencido7: '',
      textoTituloVencido21: '',
      textoComparativoAnual: '',
      codigoIds: ['200', '201', '202', '203', '204', '205', '206', '207', '208', '209', '210', '211', '212', '213', '214'],
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      valorJurosRecebido: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorDesconto: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorPrazoMedio: parseFloat(0),
      valorPrecoMedio: parseFloat(0),
      chartContasReceberDiario: {},
      corContasReceberDiario: [],
      dadosContasReceberDiario: [],
      chartShareRecebimento: {},
      corContasReceberAnual: [],
      dadosContasReceberAnual: [],
      chartDetalhesContasReceberAnual: {},
      dynamicPaddingContasReceber1: '',
      dynamicPaddingContasReceber2: '',
      dynamicPaddingContasReceber3: '',
      dynamicPaddingContasReceber4: '',
      dynamicPaddingContasReceber5: '',
      dynamicPaddingContasReceber6: '',
      dynamicPaddingContasReceber7: '',
      loadingJurosRecebido: false,
      loadingDescontoConcedido: false,
      loadingPrazoMedioVendas: false,
      loadingPrazoMedioRecebimento: false,
      loadingShareInadimplencia: false,
      textoOrientacao: '',
      carregandoTooltip: false,
      codigoAtual: null,
    }),

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)

      window.removeEventListener('resize', this.updateDynamicPadding)

      Chart.plugins.unregister(pluginContasReceber)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        Chart.plugins.register(pluginContasReceber)

        eventEmit.$emit('atualizar_texto', 'Contas Receber')

        this.updateDynamicPadding()

        window.addEventListener('resize', this.updateDynamicPadding)

        this.usuarioIdentificado = true
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        this.$router.push('/login')
      }
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingContasReceber1 = 'padding-right: 13rem !important'

          this.dynamicPaddingContasReceber2 = 'padding-right: 13rem !important'

          this.dynamicPaddingContasReceber3 = 'padding-right: 95rem !important'

          this.dynamicPaddingContasReceber4 = 'padding-right: 5rem !important'

          this.dynamicPaddingContasReceber5 = 'padding-right: 5rem !important'

          this.dynamicPaddingContasReceber6 = 'padding-right: 34rem !important'

          this.dynamicPaddingContasReceber7 = 'padding-right: 100rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingContasReceber1 = 'padding-right: 2rem !important'

          this.dynamicPaddingContasReceber2 = 'padding-right: 2rem !important'

          this.dynamicPaddingContasReceber3 = 'padding-right: 55rem !important'

          this.dynamicPaddingContasReceber4 = 'padding-right: 0rem !important'

          this.dynamicPaddingContasReceber5 = 'padding-right: 0rem !important'

          this.dynamicPaddingContasReceber6 = 'padding-right: 15rem !important'

          this.dynamicPaddingContasReceber7 = 'padding-right: 55rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPaddingContasReceber1 = 'padding-right: 11rem !important'

          this.dynamicPaddingContasReceber2 = 'padding-right: 11rem !important'

          this.dynamicPaddingContasReceber3 = 'padding-right: 11rem !important'

          this.dynamicPaddingContasReceber4 = 'padding-right: 11rem !important'

          this.dynamicPaddingContasReceber5 = 'padding-right: 11rem !important'

          this.dynamicPaddingContasReceber6 = 'padding-right: 11rem !important'

          this.dynamicPaddingContasReceber7 = 'padding-right: 11rem !important'
        } else if (window.innerWidth > 601 && window.innerWidth < 1080) {
          this.dynamicPaddingContasReceber1 = 'padding-right: 25rem !important'

          this.dynamicPaddingContasReceber2 = 'padding-right: 25rem !important'

          this.dynamicPaddingContasReceber3 = 'padding-right: 25rem !important'

          this.dynamicPaddingContasReceber4 = 'padding-right: 25rem !important'

          this.dynamicPaddingContasReceber5 = 'padding-right: 25rem !important'

          this.dynamicPaddingContasReceber6 = 'padding-right: 25rem !important'

          this.dynamicPaddingContasReceber7 = 'padding-right: 25rem !important'
        } else {
          this.dynamicPaddingContasReceber1 = 'padding-right: 2rem !important'

          this.dynamicPaddingContasReceber2 = 'padding-right: 2rem !important'

          this.dynamicPaddingContasReceber3 = 'padding-right: 48rem !important'

          this.dynamicPaddingContasReceber4 = 'padding-right: 3rem !important; margin: -1rem 0 0 -1rem;'

          this.dynamicPaddingContasReceber5 = 'padding-right: 3rem !important; margin: -1rem 0 0 -1rem;'

          this.dynamicPaddingContasReceber6 = 'padding-right: 16rem !important'

          this.dynamicPaddingContasReceber7 = 'padding-right: 48rem !important'
        }
      },

      handleUpdateDados (primeiroDia, dataFinal, select, selectVendedores, selectArea, selectRede, selectSupervisor, selectReceita, selectSegmento, selectClassificacao, selectProduto, selectCidade, selectCategoria, selectPromotor, selectLinhasProducao, primeiroDiaStatus, dateStatus, selectMotorista, selectStatusEntrega, selectOrdem, selectOpcaoOrdenacao, selectOrientacaoOrdem, selectClientes) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.select = select
        this.selectClientes = selectClientes

        this.updateDate()
      },

      async enableTexto (value) {
        if (this.codigoAtual === value && this.textoOrientacao) return

        this.codigoAtual = value
        this.carregandoTooltip = true
        this.textoOrientacao = ''

        try {
          const resposta = await Permissao.showOrientacaoIndicador(localStorage.username, localStorage.tokencontrato, value)

          if (resposta.data.status) {
            this.textoOrientacao = resposta.data.orientacao
            this.codigo = value
          }
        } catch (e) {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        } finally {
          this.carregandoTooltip = false
        }
      },

      async updateDate () {
        this.valorReceber = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorInadimplencia = 0
        this.valorClientesInadimplentes = 0

        this.showContasReceberValoresAReceber()
        this.showContasValorClientesInadimplentes()
        this.showContasValorInadimplencia()

        eventEmit.$emit('set-valores-recebidos', this.primeiroDia, this.ultimoDia, this.select, this.selectClientes)
        eventEmit.$emit('set-valores-aberto', this.primeiroDia, this.ultimoDia, this.select, this.selectClientes)
        eventEmit.$emit('set-valores-vencidos', this.primeiroDia, this.ultimoDia, this.select, this.selectClientes)
        eventEmit.$emit('set-acompanhamento-diario', this.primeiroDia, this.ultimoDia, this.select, this.textoAcompDiario, this.selectClientes)
        eventEmit.$emit('set-movimentacao-mes-a-mes', this.primeiroDia, this.ultimoDia, this.select, this.textoComparativoAnual, this.selectClientes)
        eventEmit.$emit('set-juros-desconto', this.primeiroDia, this.ultimoDia, this.select, this.selectClientes)

        this.loadingJurosRecebido = true
        this.loadingDescontoConcedido = true
        this.loadingPrazoMedioVendas = true
        this.loadingPrazoMedioRecebimento = true
        this.loadingShareInadimplencia = true

        this.valorJurosRecebido = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorDesconto = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorPrazoMedio = parseFloat(0)
        this.valorPrecoMedio = parseFloat(0)

        if (this.chartShareRecebimento.data) {
          this.chartShareRecebimento.destroy()
        }

        await ContasReceber.showJurosReceber(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato, this.selectClientes).then(resposta => {
          if (resposta.data.status) {
            this.valorJurosRecebido = resposta.data.jurosRecebido.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.msg === 'Não há títulos vencidos nos ultimos 7 dias') {
            this.valorJurosRecebido = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingJurosRecebido = false })

        await ContasReceber.showDescontoReceber(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato, this.selectClientes).then(resposta => {
          if (resposta.data.status) {
            this.valorDesconto = resposta.data.desconto.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.msg === 'Não há títulos vencidos nos ultimos 7 dias') {
            this.valorDesconto = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingDescontoConcedido = false })

        await ContasReceber.showPMV(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato, this.selectClientes).then(resposta => {
          if (resposta.data.status) {
            this.valorPrazoMedio = resposta.data.prazoMedio
          } else if (resposta.data.msg === 'Não há títulos vencidos nos ultimos 7 dias') {
            this.valorPrazoMedio = parseFloat(0)

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingPrazoMedioVendas = false })

        await ContasReceber.showPMR(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato, this.selectClientes).then(resposta => {
          if (resposta.data.status) {
            this.valorPrecoMedio = resposta.data.prazoMedio
          } else if (resposta.data.msg === 'Não há títulos vencidos nos ultimos 7 dias') {
            this.valorPrecoMedio = parseFloat(0)

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingPrazoMedioRecebimento = false })

        await ContasReceber.showShareInadimplencia(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato, this.selectClientes).then(resposta => {
          if (resposta.data.status) {
            const ctx = document.getElementById('myChart22').getContext('2d')

            const isEnable = !(window.innerWidth >= 1001 && window.innerWidth <= 1380)

            this.chartShareRecebimento = new Chart(ctx, {
              plugins: [ChartDataLabels],
              type: 'horizontalBar',
              data: {
                labels: resposta.data.labels,
                datasets: [
                  {
                    label: 'Share Inadimplência',
                    data: resposta.data.dados,
                    backgroundColor: '#f27686',
                    order: 1,
                  },
                ],
              },
              options: {
                plugins: {
                  datalabels: {
                    display: true,
                    align: 'end',
                    color: function (context) {
                      return '#000000'
                    },
                    font: {
                      size: 9,
                    },
                    formatter: (value) => {
                      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                  },
                },
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    ticks: {
                      min: 0,
                    },
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                  yAxes: [{
                    gridLines: {
                      display: false,
                    },
                    display: isEnable,
                  }],
                },
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    mode: 'label',
                    label: (tooltipItem, data) => {
                      var type = data.datasets[tooltipItem.datasetIndex].label
                      var valor = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

                      return type + ': ' + valor
                    },
                  },
                },
              },
            })
          } else if (resposta.data.msg === 'Não há clientes inadimplentes no período selecionado') {
            this.text = resposta.data.mg

            this.error = this.text

            if (this.chartShareRecebimento.data) {
              this.chartShareRecebimento.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingShareInadimplencia = false })
      },

      async showContasReceberValoresAReceber () {
        this.loading = true

        await ContasReceber.showValoresAReceber(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato, this.selectClientes).then(resposta => {
          if (resposta.data.status) {
            this.valorReceber = resposta.data.valorReceber.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.valorReceberEnviar = resposta.data.valorReceber

            localStorage.setItem('valorReceber', this.valorReceberEnviar)
          } else if (resposta.data.msg === 'Não há valores a receber no período selecionado') {
            this.valorReceber = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.valorReceberEnviar = parseFloat(0)

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      async showContasValorInadimplencia () {
        this.loadingValorInadimplencia = true

        await ContasReceber.showValorInadimplencia(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato, this.selectClientes).then(resposta => {
          if (resposta.data.status) {
            this.valorInadimplencia = resposta.data.porcentagemAtiginda.toFixed(2).replace('.', ',') + '%'
          } else if (resposta.data.msg === 'Não há valores vencidos no período selecionado') {
            this.valorInadimplencia = resposta.data.porcentagemAtiginda.toFixed(2).replace('.', ',') + '%'

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.errorValorInadimplencia = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingValorInadimplencia = false })
      },

      async showContasValorClientesInadimplentes () {
        this.loading3 = true

        await ContasReceber.showClientesInadimplentes(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato, this.selectClientes).then(resposta => {
          if (resposta.data.status) {
            this.valorClientesInadimplentes = resposta.data.clientesInadimplentes
          } else if (resposta.data.msg === 'Não há clientes inadimplestes no período selecionado') {
            this.valorClientesInadimplentes = 0

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error3 = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading3 = false })
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }

</script>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 600px) {
    /* #valoresReceber {
      font-size: 14px;
      font-weight: bold;
      margin: -3rem 0 0 -6rem;
    } */

    #iconInformationValorReceber {
      margin: -6.3rem 0 0 6.2rem;
    }

    #valorReceberId {
      margin: -3rem 0rem 0 -3rem;
      font-size: 20px;
    }

    #iconLinkDetalheAReceber {
      margin: -3.7rem 0 0 -0.5rem;
    }

    #componenteValorReceber {
      margin: 0 0 0 2rem
    }

    /* #valoresRecebido {
      font-size: 14px;
      font-weight: bold;
      margin: -2rem 0 0 -6rem;
    } */

    /* #valoresAberto {
      font-size: 14px;
      font-weight: bold;
      margin: -2rem 0 0 -6rem;
    } */

    /* #valoresVencido {
      font-size: 14px;
      font-weight: bold;
      margin: -2rem 0 0 -6rem;
    } */

    #iconInformationValorRecebidos {
      margin: -4.3rem 0 0 6.2rem !important;
    }

    #iconInformationValorVencido {
      margin: -4.1rem 0 0 6.2rem !important;
    }

    #iconInformationAcompanhamentoDiario {
      margin: 0 0 0 0 !important
    }

    /* #valorInadimplenciaId {
      margin: -0.5rem 0 0 11rem;
      font-size: 20px;
    } */

    #iconLinkDetalheInadimplencia {
      margin: 0rem 0 0 1rem;
    }

    #iconLinkDetalheClientesInadimplencia {
      margin: -0.1rem 0 0 2.7rem;
    }

    /* #valorClientesInadimplentesId {
      margin: -0.5rem 0 0 11rem;
    } */

    #tituloVencidoSeteDias {
      width: 40rem;
    }

    #tituloVencidoVinteDias {
      width: 40rem;
    }

    #iconInformationTituloVencidos7Dias {
      margin: 0 0 0 0;
    }

    #iconInformationTituloVencidos21Dias {
      margin: 0 0 0 2.5rem !important
    }

    #iconInformationValorAbertoAnoMes {
      margin: 0 0 0 2.5rem !important
    }

    #iconInformationValorAberto {
      margin: -4.3rem 0 0 6.2rem !important;
    }

    #iconInformationInadimplenciaGeral {
      margin: 0 0 0 2.5rem !important
    }

    #iconInformationClientesInadimplentes {
      margin: 0 0 0 2.5rem !important
    }

    #iconInformationShareInadimplencia {
      margin: 0 0 0 2.5rem !important
    }

    #iconInformationTituloVencidos7Dias {
      margin: 0 0 0 2.5rem !important
    }

    #iconInformationJurosRecebidos {
      margin: 0 0 0 -2.5rem
    }

    /* #valorDescontoRecebimento {
      margin: 0 0 0 2rem;
    } */

    #iconInformationDescontoConcedido {
      margin: 0 0 0 -2.5rem
    }

    /* #prazoMedioVendas {
      margin: 0 0 0 2rem;
    } */

    #iconInformationPMV {
      margin: 0 0 0 -2.5rem;
    }

    #prazoMedioRecebimento {
      margin: -1rem 0 0 0rem;
    }

    #iconInformationPMR {
      margin: 0 0 0 -2.5rem !important;
    }
  }

  @media screen
  and (min-width : 601px)
  and (max-width : 1000px)
  and (-webkit-min-device-pixel-ratio: 1) {
    /* #valoresReceber {
      font-size: 14px;
      font-weight: bold;
      margin: -1rem 0 0 -18rem;
    } */

    #iconInformationValorReceber {
      margin: -2rem 0 0 -11rem;
    }

    /* #valorReceberId {
      font-size: 22px;
      display: grid;
      align-items: center;
      margin: -0.5rem 5rem 0 15rem;
      font-weight: bold;
    } */

    #iconLinkDetalheAReceber {
      margin: -0.5rem 0 0 -3rem;
    }

    /* #valoresRecebido {
      font-size: 14px;
      font-weight: bold;
      margin: -6rem 0 0 7rem;
    } */

    /* #valoresAberto {
      font-size: 14px;
      font-weight: bold;
      margin: -2.5rem 0 0 -17.9rem;
    } */

    #iconInformationValorAberto {
      margin: -5.2rem 0 0 -11.1rem;
    }

    /* #valoresVencido {
      font-size: 14px;
      font-weight: bold;
      margin: -8.9rem 0 0 6.8rem;
    } */

    #iconInformationValorRecebidos {
      margin: -12.1rem 0 0 58.9rem;
    }

    #iconInformationValorVencido {
      margin: -18rem 0 0 58.9rem;
    }

    #bloco1CR {
      margin: -5rem 0 0 0;
    }

    #iconInformationAcompanhamentoDiario {
      margin: 0 0 0 1.6rem;
    }

    #inadimplencia {
      margin: 0 0 0 -1rem;
    }

    #iconInformationInadimplenciaGeral {
      margin: 0 0 0 -29.5rem
    }

    /* #valorInadimplenciaId {
      margin: -1.5rem 0 0 10rem;
    } */

    #iconLinkDetalheInadimplencia {
      margin: 0rem 0 0 4.2rem;
    }

    #iconInformationClientesInadimplentes {
      margin: 0 0 0 -30.2rem
    }

    #iconLinkDetalheClientesInadimplencia {
      margin: 0 0 0 6.9rem;
    }

    /* #valorClientesInadimplentesId {
      margin: -0.5rem 0 0 10rem;
    } */

    /* #shareInadimplencia {
      margin: -10rem 0 0 20rem!important;
    } */

    #iconInformationShareInadimplencia {
      margin: 0 0 0 3.9rem;
    }

    #tituloVencidoSeteDias {
      width: 40rem;
    }

    #tituloVencidoVinteDias {
      width: 40rem;
    }

    #graficoShareInadimplencia {
      width: 250px;
      margin: 0 0 0 8rem;
    }

    #iconInformationTituloVencidos7Dias {
      margin: 0 0 0 7.5rem;
    }

    #valorTituloVencidosId {
      font-size: 18px;
      display: grid;
      align-items: center;
      margin: -0.1rem 5rem 0 13.5rem;
      font-weight: bold;
    }

    #iconInformationTituloVencidos21Dias {
      margin: 0 0 0 7.2rem;
    }

    #iconInformationValorAbertoAnoMes {
      margin: 0 0 0 7.2rem;
    }

    #iconInformationJurosRecebidos {
      margin: 0 0 0 5rem
    }

    /* #valorDescontoRecebimento {
      margin: 0 0 0 2rem;
    } */

    #iconInformationDescontoConcedido {
      margin: 0 0 0 -1.7rem
    }

    /* #prazoMedioVendas {
      margin: 0 0 0 2rem;
    } */

    #iconInformationPMV {
      margin: 0 0 0 -2.5rem;
    }

    /* #prazoMedioRecebimento {
      margin: 0 0 0 2rem;
    } */

    #iconInformationPMR {
      margin: 0 0 0 -2.5rem !important;
    }
  }

  @media screen and (min-width: 1380px) and (max-width: 1650px) {
    #valorReceberId {
      margin: 1.3rem 0rem 1rem -1rem
    }

    #iconLinkDetalheAReceber {
      margin: 1.7rem 0 0 -0.5rem
    }
  }

  @media screen
  and (min-width: 1651px) {
    #valorReceberId {
      margin: 0rem 0rem 2.8rem -1rem
    }

    #iconLinkDetalheAReceber {
      margin: 0.4rem 0 0 0rem
    }
  }
</style>

<style lang="sass">
  // #bloco1
  //   margin-left: -5rem

  #valoresReceber
    font-size: 14px
    font-weight: bold

  #valoresRecebido
    font-size: 14px
    font-weight: bold
    margin: 0 0 0 -3rem

  #valoresAberto
    font-size: 14px
    font-weight: bold
    margin: 0 0 0 -3rem

  #valoresVencido
    font-size: 14px
    font-weight: bold
    margin: 0 0 0 -3rem

  #iconInformationValorRecebidos
    margin: 0 0 0 3rem

  #valorReceberId
    font-size: 20px
    display: grid
    align-items: center
    margin: 0.7rem 0rem 1.5rem -1rem
    font-weight: bold

  #iconLinkDetalheAReceber
    margin: 1rem 0 0 -0.8rem

  #iconInformationValorAberto
    margin: 0 0 0 4rem

  #iconInformationValorVencido
    margin-left: 2rem

  #valorInadimplenciaId
    font-size: 24px
    display: grid
    align-items: center
    margin: 0rem 0rem 0 0rem
    font-weight: bold

  #valorClientesInadimplentesId
    font-size: 24px
    display: grid
    align-items: center
    margin: 0rem 0rem 0 0rem
    font-weight: bold

  #valorTituloVencidosId
    font-size: 18px
    display: grid
    align-items: center
    margin: -0.1rem 5rem 0 8.5rem
    font-weight: bold

  #tituloVencidoVinteDias
    margin: 0 0 0 1rem

  #iconLinkDetalheInadimplencia
    margin: 0.5rem 0 0 -1rem

  #iconLinkDetalheClientesInadimplencia
    margin: 0.5rem 0 0 -1rem

  #iconInformationAcompanhamentoDiario
    margin: 0 0 0 4.5rem

  #iconInformationTituloVencidos7Dias
    margin: 0 0 0 2.7rem

  #iconInformationTituloVencidos21Dias
    margin: 0 0 0 2rem

  #iconInformationValorAbertoAnoMes
    margin: 0 0 0 12rem

  #colunaShare
    margin: 0 -1.5rem 0 0

  #loadingDados
    margin: 1rem 0 0 9rem

  #valorJurosRecebimento
    font-weight: bold
    margin: -3rem 0 0 0

  #iconInformationJurosRecebidos
    margin: 0 0 0 -5rem

  #valorDescontoRecebimento
    font-weight: bold
    margin: -3rem 0 0 0

  #iconInformationDescontoConcedido
    margin: 0 0 0 -1.7rem

  #prazoMedioVendas
    font-weight: bold
    margin: -3rem 0 0 0

  #iconInformationPMV
    margin: 0 0 0 -0.7rem

  #prazoMedioRecebimento
    font-weight: bold
    margin: -3rem 0 0 0

  #iconInformationPMR
    margin: 0 0 0 -1rem

  .container
    max-width: 100%

  .highlighted-item
    background-color: #2863af
    padding: 16px
    color: white
    margin: -1rem 0 0 0

  #listItemContasReceber
    margin: -2rem 0 0 -1rem

  #listItemContasReceberInadimplentes
    margin: -2rem 0 0 -1rem

  #listItemTitulosVencidosReceberInadimplentes
    margin: -2rem 0 0 -1rem

  #componenteContasReceberInadimplentes
    margin: -3rem 0 0 0rem

  .custom-loader
    animation: loader 1s infinite
    display: flex
    @-moz-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-webkit-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-o-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)

</style>
